import React from 'react'
import { makeStyles } from 'tss-react/mui'
import type { Theme } from '@mui/material/styles'
import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'
import ClickAwayListener from '@mui/material/ClickAwayListener'

export type QuestionTooltipProps = {
  children: string
  icon?: React.ReactNode
}

const useStyles = makeStyles()((theme: Theme) => ({
  icon: {
    display: 'inline-flex',
    padding: theme.spacing(0, 0.5),
  },
}))

const IconTooltip: React.FC<{
  children: string
  icon: React.ReactNode
}> = ({ children, icon }) => {
  const { classes } = useStyles()
  const [open, setOpen] = React.useState(false)

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <Tooltip
        onClose={() => setOpen(false)}
        open={open}
        disableFocusListener
        disableHoverListener
        disableTouchListener
        title={children}
        arrow
      >
        <IconButton
          className={classes.icon}
          onClick={() => setOpen(true)}
          size="large"
        >
          {icon}
        </IconButton>
      </Tooltip>
    </ClickAwayListener>
  )
}

export default IconTooltip
